import React, { Component } from 'react';
import { getJsonItemInvariantCase } from '../Utilities/JsonFunctions.js'
import FormExplanationValidation from './FormExplanationValidation.js';

declare var $;
declare var globalSns;

class NamezzzEduOrg extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.state = {
            activeCountry: this.props.seqcountry
        }
    }

    onChange(e, data) {
        this.props.onChange(e, data);
    }

    onKeyPress(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            
            if (this.props.onEnter == null) {
                return;
            }
            this.props.onEnter(e);
        }
    }

    componentDidMount() {
       this.setAutoComplete();
    }

    componentWillUnmount() {
        this.$el.autocomplete('destroy');
    } 

    componentDidUpdate() {
        this.$el.val(this.props.value);

        if (this.state.activeCountry !== this.props.seqcountry) {
            this.setState({
                activeCountry: this.props.seqcountry
            });
            
            this.$el.autocomplete('destroy').removeClass('xdsoft_input');
            this.setAutoComplete();
        }
    }

    setAutoComplete() {
        var url = globalSns.webApiUrl + "/api/organisations/education/search?q=%QUERY%&seqcountry=" + this.props.seqcountry;
        var _this = this;

        this.$el = $(this.el);
        this.$el.val(this.props.value);
        this.$el.autocomplete({
            source: [
                 {
                     url: url,
                     type: 'remote',
                     ajax: {
                         dataType: 'json'
                     }
                 }
            ],
            valueKey: 'text',
            titleKey: 'text',
            showHint: false,
            visibleLimit: 10,
            limit: 10000,            
            replace: function( url,query ){
                if (query.length < 2) {
                    query = "";
                }
                return url.replace('%QUERY%',encodeURIComponent(query));
            }
        }).on("autocompleted.xdsoft", function(e, data) {
            _this.onChange(e, data.id);
        }).on('blur', function(e) {
            var item = getJsonItemInvariantCase($(this).autocomplete("getSource")[0].xhr.responseJSON, "text", e.target.value);
            if (item != null)
                _this.onChange(e, item.id)
        });
    }

    render() {
        let requiredMark = this.props.required ? <span className="required-mark">*</span> : null;

        return (
            <div className="tr">
                {
                    (this.props.text) ?
                    <div className="FieldLabel td">
                        <label htmlFor={this.props.id}>{this.props.text}
                            {requiredMark}
                        </label>
                    </div> :
                    ""
                }
                <div className="EditingFormValueCell td">
                    <input type="text" id={this.props.id} disabled={this.props.disabled} ref={el => this.el = el} maxLength="200" className="form-control" onChange={this.onChange} onKeyPress={this.onKeyPress} />
                    <FormExplanationValidation id={this.props.id} explanation={this.props.explanation} showValidation={this.props.showValidation} validationText={this.props.validationText} />
                </div>
            </div>
        );
    }
}

export default NamezzzEduOrg;


// WEBPACK FOOTER //
// ./src/Fields/NamezzzEduOrg.js